/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {Typography} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import isNil from 'lodash.isnil';
import {translate} from '@ion/core/src/locale/locale';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {StarsFillIcon} from '@ion/dls/src/icons/StarsFillIcon';
import {StarsIcon} from '@ion/dls/src/icons/StarsIcon';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {IconSize} from '@ion/dls/src/types/types';
import {LabelTypography} from '@ion/dls/src/typography/LabelTypography';
import {removeTempQueries} from './ModularSearchWidget';
import {useStyles} from './SearchSuggestions';

interface SavedQueriesListProps {
  pageName: string;
  onSavedQuerySelect: (query: any) => void;
  createChips?: Function;
  queryName?: string;
}

export interface SavedQueryItem {
  query: string,
  name: string;
}

export type SavedQueryType = {
  pageName: string;
  query: SavedQueryItem[];
  createdAt: Date;
  queryName?: string;
}

const SaveQueriesList = ({
  pageName,
  queryName,
  onSavedQuerySelect
}: SavedQueriesListProps) => {
  const classes= useStyles({
    isFixedWidth : true
  });
  const savedQueries = removeTempQueries(pageName);

  const selectQuery = useCallback(function({name, query}) {
    return () => {
      onSavedQuerySelect({name, query});
    };
  }, []);
  if (savedQueries?.query?.length) {
    return (
      <>
        {!isNil(queryName) && (
          <MenuItem key='saved-query-selected'
            classes={{root: `${classes.suggestionItem}, ${classes.selectedListItem}`}}>
            <StarsFillIcon size={IconSize.medium} color={dlsColor('grey3')} />
            <LabelTypography className={classes.label}>{queryName}</LabelTypography>
          </MenuItem>
        )}
        {savedQueries.query.map(({name, query}: SavedQueryItem, index: number) => {
          if (name && name !== queryName && query && safeJSONParse(query)?.length) {
            return (
              <MenuItem key={`saved-query${index}`}
                classes={{root: classes.suggestionItem}}
                onClick={selectQuery({name, query})}>
                <StarsIcon size={IconSize.small}/>
                <LabelTypography className={classes.label}>{name}</LabelTypography>
              </MenuItem>
            );
          }
          return null;
        })}

      </>
    );
  }
  return (
    <MenuItem disabled>
      <Typography style={{textAlign: 'center', fontSize: 12}}>
        {translate('common:modularsearch.nosavedquery')}
      </Typography>
    </MenuItem>
  );
};
export default SaveQueriesList;
